module.exports = __webpack_public_path__ + "static/media/logo.100104b6.png";